import { createOffscreenCanvas, drawWithShaders, setupWebglCanvas } from '@hackvegas-2025/shared';
import { state } from './state';
import { updateAndDrawTerminal, textHeight } from './terminal';
import { playLoadingSound } from './audio';

function main() {
  const { offscreenCanvas, offscreenCtx } = createOffscreenCanvas();
  const { canvas, gl, shaderData } = setupWebglCanvas(offscreenCanvas, offscreenCtx);
  document.body.appendChild(canvas);

  document.fonts.ready.then(() => {
    state.fontsLoaded = true;
  });

  window.onclick = () => {
    if (!state.focused) {
      state.focused = true;
      playLoadingSound();
    }
  };

  window.onwheel = (e) => {
    if (state.scrolled === null) {
      state.scrolled = state.lastLineShown;
    }
    const scrollSpeed = 0.1;
    state.scrolled -= -e.deltaY * scrollSpeed;
  };

  const draw = () => {
    drawWithShaders(gl, canvas, shaderData, updateAndDrawTerminal, state.color, textHeight);
    requestAnimationFrame(draw);
  };

  draw();
}

main();
